import styled from 'styled-components'

export const Root = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
  height: ${ (props) => props.height };
  ${ (props) =>
    ((props.isMobile && props.isFullscreen) ||
      (props.mapPosition === 'detailView' && props.isFullscreen)) &&
    `
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: ${
          props.mapPosition === 'detailView' ||
          (props.mapPosition === 'resultList' && props.isMobile)
            ? props.theme.zIndices.fullscreenMap
            : props.theme.zIndices.modal
        };
        ` }

  @media print {
    display: none;
  }
`

export const FullscreenButtonIcon = styled.span`
  font-size: 22px;
  line-height: 1;
  color: #525252;
`

// google maps default fullscreen button styles
export const FullscreenButton = styled.button`
  background: #fff;
  border: 0;
  margin: 10px;
  padding: 0;
  cursor: pointer;
  user-select: none;
  border-radius: 2px;
  height: 40px;
  width: 40px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    outline: 0;

    & > ${ FullscreenButtonIcon } {
      color: #303030;
    }
  }
`

export const CenterMarker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  background: #f67503;
  width: 20px;
  height: 20px;
  border-radius: 50%;
`

export const PrivacyPolicyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
